export default __webpack_public_path__ + "static/media/Terms.ef5aa665.svg";